import { render, staticRenderFns } from "./UserNumberModal.vue?vue&type=template&id=424be70c&scoped=true"
import script from "./UserNumberModal.vue?vue&type=script&lang=js"
export * from "./UserNumberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424be70c",
  null
  
)

export default component.exports